import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  TypeOfShotQueryInput,
  TypeOfShotQueryResult,
} from "../../generated/gql/graphql";

const GET_TYPE_OF_SHOTS = gql`
  query TypeOfShots($query: TypeOfShotQueryInput) {
    typeOfShots(query: $query) {
      items {
        name
        id
      }
      totalCount
      limit
      offset
      page
    }
  }
`;

export default function useTypeOfShots(
  query?: TypeOfShotQueryInput
): QueryResult<{ typeOfShots: TypeOfShotQueryResult }> {
  return useQuery(GET_TYPE_OF_SHOTS, {
    variables: {
      query,
    },
    fetchPolicy: "cache-and-network",
  });
}
